import { React } from 'react'
import { Checkbox } from 'antd'
import classNames from 'classnames'

import { getAvatarURL } from 'pages/records/components/helper'

const getTableInfo = (styles, selectedRowKeys, onSelectChange) => {
  const onRow = (record) => {
    return {
      onClick: (e) => {
        console.log(' - click ', e, record)

        // 체크박스나 버튼 클릭이 아닌 경우에만 선택 토글
        if (e.target.type !== 'checkbox' && !e.target.closest('.ant-checkbox-wrapper')) {
          const key = record.key || record.id
          const isSelected = selectedRowKeys && selectedRowKeys.includes(key)
          console.log(' - isSelected ', isSelected)

          if (onSelectChange) {
            if (isSelected) {
              onSelectChange(
                selectedRowKeys.filter((k) => k !== key),
                selectedRowKeys.filter((k) => k !== key).map(() => record),
              )
            } else {
              onSelectChange(
                [...(selectedRowKeys || []), key],
                [...(selectedRowKeys || []), key].map(() => record),
              )
            }
          }
        }
      },
    }
  }

  const columns = [
    {
      dataIndex: 'id',
      key: 'avatar',
      width: 32,
      render: (_, record) => {
        console.log(' --- record record: ', record)

        const avatarUrl = () => {
          if (record.avatar_url) {
            return record.avatar_url
          }

          return getAvatarURL(record.user_name, record.user_email, [])
        }
        return <img src={avatarUrl()} alt={record.user_email} className={styles.avatar} />
      },
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => {
        const { user_email: userEmail, user_name: userName } = record

        return (
          <div className={classNames(styles.info)}>
            <span className={classNames(styles.name)}>{userName}</span>
            <span className={classNames(styles.name)}>{userEmail}</span>
          </div>
        )
      },
    },
    {
      key: 'selection',
      width: 48,
      render: (_, record) => {
        const key = record.key || record.id
        const isSelected = selectedRowKeys && selectedRowKeys.includes(key)

        return (
          <Checkbox
            checked={isSelected}
            onChange={(e) => {
              e.stopPropagation()
              const { checked } = e.target

              if (onSelectChange) {
                if (checked) {
                  onSelectChange(
                    [...(selectedRowKeys || []), key],
                    [...(selectedRowKeys || []), key].map(() => record),
                  )
                } else {
                  onSelectChange(
                    (selectedRowKeys || []).filter((k) => k !== key),
                    (selectedRowKeys || []).filter((k) => k !== key).map(() => record),
                  )
                }
              }
            }}
          />
        )
      },
    },
  ]

  return { columns, onRow }
}

export default getTableInfo
